module.exports = __webpack_public_path__ + "img/logo_hnxy.66497c8b.png";